var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArchiveBoxIcon, EllipsisHorizontalIcon, TrashIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { TfiSave } from "react-icons/tfi";
import { OPEN_EDIT_TASK_MODAL } from "../../../constants";
import { useTaskActions } from "../../../hooks/actions/useTaskActions";
import { ActivePipelineContext } from "../../../providers/ActivePipelineContextProvider";
import { AppContext } from "../../../providers/AppContextProvider";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { WPQTDropdown, WPQTDropdownIcon, WPQTDropdownItem, } from "../WPQTDropdown";
function TaskControlsDropdown({ task }) {
    const { modalDispatch } = useContext(ModalContext);
    const { state: { activePipeline }, fetchAndSetPipelineData, } = useContext(ActivePipelineContext);
    const { state: { isUserAllowedToDelete }, } = useContext(AppContext);
    const { deleteTask, archiveTask } = useTaskActions();
    const openTaskEditModal = (e) => {
        e.stopPropagation();
        modalDispatch({
            type: OPEN_EDIT_TASK_MODAL,
            payload: {
                taskToEdit: task,
            },
        });
    };
    return (_jsxs(WPQTDropdown, { menuBtn: ({ active }) => (_jsx(WPQTDropdownIcon, { isActive: active, IconComponent: EllipsisHorizontalIcon })), children: [_jsx(WPQTDropdownItem, { text: __("Archive task", "quicktasker"), icon: _jsx(ArchiveBoxIcon, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: (e) => {
                    e.stopPropagation();
                    archiveTask(task.id, () => {
                        fetchAndSetPipelineData(activePipeline.id);
                    });
                } }), _jsx(WPQTDropdownItem, { text: __("Edit task", "quicktasker"), icon: _jsx(TfiSave, { className: "wpqt-icon-blue wpqt-size-3" }), onClick: openTaskEditModal }), isUserAllowedToDelete && (_jsx(WPQTDropdownItem, { text: __("Delete task", "quicktasker"), icon: _jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-4" }), onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.stopPropagation();
                    yield deleteTask(task.id, () => {
                        fetchAndSetPipelineData(activePipeline.id);
                    });
                }), className: "!wpqt-mb-0" }))] }));
}
export { TaskControlsDropdown };
